import React, {useEffect, useState} from 'react';
import SentenceForm from "../../components/common/SentenceForm";
import Container from "@material-ui/core/Container";
import {makeStyles} from "@material-ui/core";
import ScrollableAnchor from "react-scrollable-anchor";
import Radio from "@material-ui/core/Radio";
import clsx from "clsx";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Family from "./Family";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {
  answerState, familyGridTitle,
  familyState,
  menuCheckSelector,
  selectedMenuItemState,
  surveyDataState, userState
} from '../../state/globalState'
import FormControl from "@material-ui/core/FormControl";
import RadioGroup from "@material-ui/core/RadioGroup";
import { findFamilyInfo } from '../../lib/api/survey'

const useStyles = makeStyles(theme => ({
    root: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
    },
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#1b6817',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    textField: {
        width: 300
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

/**
 * 설문 문항 컴포넌트
 */
const Survey7 = (props) => {
    const userInfo = useRecoilValue(userState);
    const surveyData = useRecoilValue(surveyDataState);
    const [family, setFamily] = useRecoilState(familyState);
    const [answer, setAnswer] = useRecoilState(answerState);
    const setSelectedMenuItem = useSetRecoilState(selectedMenuItemState);
    const setMenuCheck = useSetRecoilState(menuCheckSelector);
    const familyAplyYn = answer.familyAplyYn;
    const [openSubQuestion, setOpenSubQuestion] = useState(familyAplyYn === "1");
    const classes = useStyles();
    const setFamilyGridTitle = useSetRecoilState(familyGridTitle)

    useEffect(() => {
        const rel = surveyData[15].rel;
        rel.map((item) => {
            // dispatch(changeVisible({
            //     step: item,
            //     hide: false
            // }));
            //
            // dispatch(setHidden({
            //     key: 'SURVEY_' + item,
            //     hide: false
            // }));

            return true;
        });
    }, []);

    const getPreYearFamilyinfo = async () => {
      const { data } = await findFamilyInfo(userInfo.stdYear,userInfo.corprInfoDiviNo,userInfo.citizno);
      return data;
    }

    const handleInputAnswer = async (e, column) => {
        const { value, name } = e.target;
        const rel = surveyData[15].rel;

        const newState = {
            ...answer,
            [column]: value
        }
        setAnswer(newState);

        setSelectedMenuItem('SURVEY_15');
        setMenuCheck(value !== '');

        if (rel !== undefined && name === "true") {
            setOpenSubQuestion(false);
            setFamily([]);
        } else if (rel !== undefined && name === "false") {
            const res = await getPreYearFamilyinfo();
            // console.log("API Response:", res); // 응답 확인용 로그
            if (res.payload.target && res.payload.target.length > 0) {
                // console.log(res.payload.target);
                // 새로운 배열을 만들어서 한 번에 업데이트
                const newFamilyData = res.payload.target.map(item => ({
                  kognrFmifSeq: item.PoFamilyInfo.kognrFmifSeq,
                  famyNm: item.PoFamilyInfo.famyNm,
                  famySsnNo: item.PoFamilyInfo.famySsnNo,
                  famyRltGcd: item.PoFamilyInfo.famyRltGcd,
                  famyIncomeAmt: item.PoFamilyInfo.famyIncomeAmt,
                  famyCareYn: item.PoFamilyInfo.famyCareYn,
                  famyObsYn: item.PoFamilyInfo.famyObsYn,
                  flag: item.flag
                }));

                setFamily(newFamilyData);
                setFamilyGridTitle("부양가족으로 신청하실 가족정보를 입력하세요.\n(직전연도에 EY에서 준비한 종합소득세 신고에 반영된 부양가족 정보는 아래와 같습니다.)");
              }
          setOpenSubQuestion(true)
        }
    };

    const StyledRadio = (props) => {
        return (
            <Radio
                disableRipple
                color="default"
                checked={familyAplyYn === props.value}
                checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                icon={<span className={classes.icon} />}
                onChange={(e) => handleInputAnswer(e, 'familyAplyYn')}
                {...props}
            />
        );
    };

    const step15List = surveyData[15].text.map((item) => {
        // item.content = item.content.replace('$stdYear$', userInfo.stdYear);

        return (
            <>
                <FormControlLabel key={'15-' + item.key} name={String(item.toggle)} value={item.key}
                                  control={<StyledRadio />} label={item.content}/>
            </>
        )
    });

    const isDisplay = openSubQuestion === true ? 'block' : 'none';

    return (
        <>
            <ScrollableAnchor id={"15"}>
                <div>
                <Container style={{background: 'transparent', marginBottom: '10px'}}>
                    <SentenceForm
                        title={surveyData[15].title}
                        sentences={surveyData[15].questions}
                        step={15}
                    />
                    <FormControl component="fieldset" style={{margin: '10px 20px 0 25px'}}>
                        <RadioGroup defaultValue="0" aria-label="" name="">
                            {step15List}
                        </RadioGroup>
                    </FormControl>
                </Container>
                </div>
            </ScrollableAnchor>

            <ScrollableAnchor id={"16"}>
                <div style={{display: isDisplay, marginLeft: "25px"}}>
                    <Family step={16} />
                </div>
            </ScrollableAnchor>
        </>
    );
};

export default Survey7;
